<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Form ref="form" :label-width="100" :model="formFields" :rules="ruleValidate">
        <FormItem label="新密码:" prop="password">
          <Input
            v-model="formFields.password"
            type="password"
            password
            placeholder="请输入新密码..."
            size="small"
          />
        </FormItem>
        <FormItem label="再一次密码:" prop="confirmPassword">
          <Input
            v-model="formFields.confirmPassword"
            type="password"
            password
            placeholder="请再一次输入密码..."
            size="small"
          />
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
const qs = require('qs')
import request from '@/utils/request'
export default {
  name: 'UserResetPasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    icon: {
      type: String,
      default: '"md-create'
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      modal: true,
      submit: false,
      formFields: { password: '', confirmPassword: '' },
      ruleValidate: {
        password: [
          { required: true, message: '密码不能为空!', trigger: 'blur' },
          { min: 4, message: '密码长度最少为4位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空!', trigger: 'blur' },
          { min: 4, message: '密码长度最少为4位', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    action() {
      return this.$config.apiContextPath + '/member/' + this.id + '/action/resetPassword'
    },
    title() {
      return this.caption || '重置密码'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
    },
    isFormInputValid: function() {
      return this.formFields.password === this.formFields.confirmPassword
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.isFormInputValid()) {
            this.$Notice.error({
              title: '出错啦',
              desc: '两次密码输入不一致'
            })
            return
          }
          this.submit = true
          request({
            url: this.action,
            method: 'POST',
            data: qs.stringify(this.formFields),
            headers: { 'Content-type': 'application/x-www-form-urlencoded;charset=utf-8' }
          }).then(res => {
            this.$Notice.success({
              title: '密码重置成功'
            })
            this.submit = false
            this.closeModal(true)
          }).catch(error => {
            this.submit = false
            console.log(error)
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

